import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    dear,
    taxpayers,
    taxCode,
    notificationAddress,
    phone,
    email,
    textNumber,
    business,
    title,
    sites,
    unitHeads,
    dateFounded,
  },
} = checkout;

const validation = Yup.object().shape({
  [dear.name]: Yup.string().required(dear.errorMsg),
  [notificationAddress.name]: Yup.string().required(notificationAddress.errorMsg),
  [taxpayers.name]: Yup.string().required(taxpayers.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),

  [phone.name]: Yup.string().required(phone.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg),
  [textNumber.name]: Yup.string().required(textNumber.errorMsg),
  [business.name]: Yup.string().required(business.errorMsg),
  [title.name]: Yup.number().required(title.errorMsg),
  [sites.name]: Yup.string().required(sites.errorMsg),
  [unitHeads.name]: Yup.string().required(unitHeads.errorMsg),
  [dateFounded.name]: Yup.number().required(dateFounded.errorMsg),
});

export default validation;
